import React from 'react'
import BaseIcon from 'react-icon-base'

const Linkedin = props => (
  <BaseIcon width="18" height="18" viewBox="0 0 18 18" {...props}>
    <path
      fill="#0077B5"
      d="M13.53 5.68c3.775 0 4.47 2.488 4.47 5.718v6.601L14.272 18v-5.991c-.004-1.371-.092-3.042-1.94-3.042-1.94 0-2.238 1.515-2.238 3.082v5.95H6.367V5.982h3.58v1.639h.052c.497-.944 1.715-1.94 3.53-1.94zm-9.501.303V18H.297V5.983h3.732zM2.162 0c1.192 0 2.16.968 2.161 2.162 0 1.193-.968 2.181-2.162 2.181C.969 4.343 0 3.355 0 2.162 0 .968.968 0 2.162 0z"
    />
  </BaseIcon>
)

export default Linkedin
